declare module '@mui/system' {
  interface Shape {
    borderRadiusXsm: number | string
    borderRadiusSm: number | string
    borderRadiusMd: number | string
    borderRadiusButton: number | string
  }
}

const shape = {
  borderRadiusXsm: 4,
  borderRadius: 9.6,
  borderRadiusSm: 12,
  borderRadiusMd: 16,
  borderRadiusButton: 18,
}

export default shape
